import React from 'react';
import styled from 'styled-components';
import { Captions, SmallSectionHeader } from 'components/Typography';
import { Box } from '@material-ui/core';

export const StyledCaptions = styled(Captions)`
  &&& {
    letter-spacing: 0;
    line-height: 16px;
    font-size: 13px !important;
    margin-bottom: 0px;
  }
`;

export const SizedCaptions = styled(Captions)`
  &&& {
    font-size: 13px !important;
  }
`;

export const ItemWrapper = styled(({ reverse, ...otherProps }) => (
  <Box {...otherProps} />
))`
  display: flex;
  align-items: center;
  width: 100%;
  img {
    margin-right: ${(props) => (props.reverse ? '0px' : '6px')} !important;
    margin-left: ${(props) => (props.reverse ? '6px' : '0px')} !important;
  }
`;
export const StyledImg = styled.img`
  &&& {
    width: 39px;
    height: 39px;
  }
`;
export const SizedSmallSectionHeader = styled(SmallSectionHeader)`
  && {
    margin-bottom: 16px;
    letter-spacing: 0;
    line-height: 23px;
  }
`;
export const StyledList = styled.ul`
  margin: 0px;
  padding-left: 25px;
`;
export const AccordionDetailsCaptions = styled(Captions)`
  &&& {
    letter-spacing: 0;
    line-height: 16px;
    margin-bottom: 5px;
  }
`;
